import gql from 'graphql-tag';
// import { getFYList } from '../../../util/shared/tmc-global';
import { clients } from '../../../util/clients';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';

const { backend } = clients.direct;

const fields = {
  _id: '',
  mtgCode: '',
  servicingCompanyCode: '',
  mtgCoName: '',
  addressOne: '',
  addressTwo: '',
  addressThree: '',
  emailAddress: '',
  phoneNumber: '',
  mtgExt: '',
  faxNumber: '',
  mtgServicingCompany: '',
  list: '',
  statements: '',
  fullTaxroll: '',
  notes: '',
  contactPersonOne: '',
  cpOneEmailAddress: '',
  cpOnePhoneNumber: '',
  cpOneExt: '',
  cpOneNote: '',
  contactPersonTwo: '',
  cpTwoEmailAddress: '',
  cpTwoPhoneNumber: '',
  cpTwoExt: '',
  cpTwoNote: '',
};

export const taxMortgageCodesShared = {
  namespaced: true,
  state: () => ({
    isDialog: false,
    selectedItems: [],
    mortgageCodes: [],
    taxMortgageCodes: [],
  }),
  mutations: {
    setDialog(state, isDialog) {
      state.isDialog = isDialog;
    },
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },
    setMortgageCodes(state, items) {
      state.mortgageCodes = items;
    },
    setTaxMortgageCodes(state, list) {
      state.taxMortgageCodes = list;
    },
  },
  getters: {
    getDialog(state) {
      return state.isDialog;
    },
  },
  actions: {
    async loadTaxMortgageCodesSharedRecords({ commit, dispatch }, {
      criteria, baseCrudKey, postProcessTrans, isItSetState,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query taxMortgageCodes($criteria: taxMortgageCodesCriteriaType) {
            taxMortgageCodes(criteria: $criteria) {
              ${fieldsToGqlString(fields)},
              }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);

        const { taxMortgageCodes } = results.data;
        const processedTransData = postProcessTrans
          ? postProcessTrans(taxMortgageCodes) : taxMortgageCodes;
        if (isItSetState) commit('setTaxMortgageCodes', processedTransData);
        else commit('base/crud/setItems', [baseCrudKey, processedTransData], { root: true });
        return taxMortgageCodes;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting Mortgage-Codes-List.', { root: true });
      }
      return [];
    },
    async upserttaxMortgageCodes({ dispatch, rootGetters, commit }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upserttaxMortgageCodes($item: taxMortgageCodesInputType!)  {
            upserttaxMortgageCodes(upsert: $item) {
              ${fieldsToGqlString(fields)},
            }
          }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const taxData = rootGetters['base/crud/items'](baseCrudKey);
        const newTaxUnit = results.data.upserttaxMortgageCodes;
        const newList = mergeByIdNewAtTop(taxData || [], newTaxUnit);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the Mortgage-Codes-List', { root: true });
      }
    },
    async deleteMortgageCodes({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deletetaxMortgageCodes ($id: ID!)  {
            deletetaxMortgageCodes(id: $id) {
                  _id
                }
              }`,
          variables: {
            id: item._id,
          },
        });
        clients.handleGQLErrors(results, commit);
        const delId = results.data.deletetaxMortgageCodes._id;
        const taxData = rootGetters['base/crud/items'](baseCrudKey);
        const updatedData = taxData.filter((d) => d._id !== delId);
        commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
        commit('base/crud/setIsVisible', [baseCrudKey, false], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem deleting the To Mortgage-Codes-List', { root: true });
      }
    },
  },
};

export default taxMortgageCodesShared;
